import { useEffect } from 'react';
import pclnExperimentation from '@pcln/experimentation';
var HandleSetiActions = function (_a) {
    var _b = _a.setiValues, setiValues = _b === void 0 ? [] : _b;
    useEffect(function () {
        if (setiValues === null || setiValues === void 0 ? void 0 : setiValues.length) {
            setiValues.forEach(function (seti) {
                pclnExperimentation.fireImpression(seti);
            });
        }
    }, []);
    return null;
};
export default HandleSetiActions;
//# sourceMappingURL=HandleSetiActions.js.map